/*
  tt-units.js - the imperial / metric switch.

  Sets one attribute on <html>; assets/tt-units.css does the rest. No fetch, no
  re-render, no per-card state - both values are already in the page.

  THE CHOICE IS REMEMBERED, because a shopper who thinks in millimetres thinks
  in millimetres on the next page too. layout/theme.liquid reads the same key in
  the <head> and applies it before first paint, so this file never causes a flip.

  Delegated from the document: pagination and Dawn's section rendering both
  replace the toolbar the control lives in.
*/
(function () {
  'use strict';

  if (window.__ttUnits) return;
  window.__ttUnits = true;

  var KEY = 'tt-units';

  function apply(units) {
    var root = document.documentElement;
    if (units === 'metric') root.setAttribute('data-units', 'metric');
    else root.removeAttribute('data-units');

    document.querySelectorAll('[data-units-set]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.dataset.unitsSet === (units || 'imperial') ? 'true' : 'false');
    });
  }

  /* The head script has already set the attribute; this syncs the BUTTONS to it,
     since they are rendered server-side with imperial pressed. */
  document.addEventListener('DOMContentLoaded', function () {
    apply(document.documentElement.getAttribute('data-units') || 'imperial');
  });

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-units-set]');
    if (!btn) return;
    event.preventDefault();

    var units = btn.dataset.unitsSet;
    apply(units);
    try { localStorage.setItem(KEY, units); } catch (e) { /* private mode: the
      switch still works, it just will not be remembered. */ }
  });
})();
